<!--
 * @Autor: yingna.gao
 * @Date: 2022-07-07 14:11:54
 * @LastEditTime: 2022-07-19 14:43:36
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/views/standard/cockpit/components/workbench-item.vue
-->
<template>
  <draggable v-model="menuList" class="clearfix" :disabled="draggabled">
    <div v-for="(item, index) in menuList" :key="item.id" class="menuList" :class="{ menuActive: !!item.checked && isEdit, menuHover: isEdit }" @click="itemActive(item)">
      <div class="menuList-icon">
        <svg-icon :icon-class="item.menuIconExt ? item.menuIconExt : 'inspectStrategy'" style="width:36px;height:36px;"></svg-icon>
      </div>
      <p class="menuList-text">{{item.menuName}}</p>
      <i v-if="showDelete" class="menuList__del" @click="delCheckedMenu(index, item)"></i>
    </div>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "WorkbenchItem",
  components: {
    draggable
  },
  props: {
    itemList: {
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    draggabled: {
      type: Boolean,
      default: true
    },
    isJump: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menuList: []
    };
  },
  watch: {
    itemList(val) {
      this.menuList = JSON.parse(JSON.stringify(val));
    }
  },
  methods: {
    itemActive(item) {
      if (this.isEdit) {
        this.$emit("getChekedMenu", item);
      } else if (this.isJump) {
        const path = item.menuPath;
        this.$router.push({ path });
      }
    },
    delCheckedMenu(index, item) {
      this.$emit("delCheckedMenu", index, item);
    }
  }
};
</script>

<style scoped lang='scss'>
.menuList{
    width:88px;
    float: left;
    text-align: center;
    cursor: pointer;
    position: relative;
    &.menuActive{
         background: #FFFFFF;
         .menuList-icon{
              border: 1px dashed #00B259;
            box-shadow: 0px 0px 8px 2px rgba(0, 178, 89, 0.299525);
            &.menuHover{
                &:hover{
                border: 1px dashed #00B259;
                box-shadow: 0px 0px 8px 2px rgba(0, 178, 89, 0.299525);
            }
          }
         }
     }
}
.menuList-icon{
    width:56px;
    height:56px;
    background: #F6FAFF;
    border-radius: 20px;
    margin: 0 auto 8px;
    border:1px solid #F6FAFF;
    display: flex;
    justify-content: center;
    align-items: center;
    &.menuHover{
        &:hover{
        border:1px solid #00B259;
        box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.03);
    }
    }
}
.menuList-text{
    color: #666666;
    line-height: 20px;
    height:44px;
    min-height: 44px;
}
.menuList__del{
     cursor: pointer;
      position: absolute;
      top:-8px;
      right:0;
      width:24px;
      height:24px;
      background: url("../../../../assets/images/con_del_model_icon.png");
      background-size: 24px 24px;
     &:hover{
        background: url("../../../../assets/images/con_del_model_hover_icon.png");
        background-size: 24px 24px;
    }
}
</style>
